import * as React from "react";
import {
  ArrayInput,
  Edit,
  EditProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const BenefitsEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="sectionTitle" label="benefits.title" />

          <TextInput
            fullWidth
            source="sectionSubtitle"
            label="benefits.subtitle"
          />
          <TextInput
            fullWidth
            source="sectionDescription"
            label="benefits.description"
          />

          <ArrayInput source="benefits" label="benefits.benefits">
            <SimpleFormIterator fullWidth>
              <ImageCropInput
                slot="icon"
                fullWidth
                sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
                label={false}
                source="icon"
                format={(
                  // Unlike bannerImage/sectionImage/cover (plain filename
                  // strings), a saved benefit's icon is always the
                  // {src, title} object pl-back's benefits.service.ts
                  // stores it as (see BenefitsDescription.icon: FileDto) -
                  // never a bare string, so this shape doesn't fit
                  // StoredImage.
                  value: any
                ) => {
                  if (!value) return [];
                  if (typeof value.src === "string" && !value.rawFile)
                    return [
                      {
                        src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value.src}`,
                      },
                    ];
                  return value;
                }}
              />

              <TextInput
                fullWidth
                source="title"
                label="benefits.benefitTitle"
              />
              <TextInput
                fullWidth
                source="description"
                label="benefits.benefitDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  );
};

export default BenefitsEdit;
